export const urlGetPaperList = "/api/XOrg/BookMaterial/getPaperList"; 
export const urlDelPaper = "/api/XOrg/BookMaterial/deletePaperById"; 
export const urlAddPaper = "/api/XOrg/BookMaterial/addPapperInfo";
export const urlUpdatePaperScore = "/api/XOrg/BookMaterial/updatePaperScore";
export const urlUpdatePaperName = "/api/XOrg/BookMaterial/updatePaperName";

import http from 'lib//http';

export interface IGetPaperList {
    code: string;
    list: {
        Id: string;
        DateCreated: string;
        CreatorName: string;
        PaperName: string;
        CourseName: string;
        QuestionCount: number;
        TotalScore: string;
        PaperType: number;
    }[];
    pagination: {
        pageIndex: string;
        pageSize: string;
        totalCount: string;
    };
    myid: string;
    otherid: string;
}

export interface IAddPaperInfo {
    code: number;
    msg: string;
    paperId: string;
}

// 获取测验列表
export function GetPaperList(schoolCourseId: string,courseId: string, paperType: string, page?: string, paperName?: string, pageSize?: number) {
    return http.get<IGetPaperList>(urlGetPaperList, {
        params: {
            paperType,
            courseId,
            schoolCourseId,
            page,
            paperName,
            pageSize
        }
    });
}

// 删除测验
export function DelPaper(ids: Array<string>) {
    return http.post(urlDelPaper, { ids });
}

// 创建测验
export function AddPaper(schoolCourseId: string,courseId: string ,paperType: string, paperName?: string,userType?:number) {
    return http.post<IAddPaperInfo>(urlAddPaper, { schoolCourseId,courseId ,paperType, paperName,userType });
}

export interface IUpdatePaperScore {
    code: number;
    msg: string;
}
export function UpdatePaperScore(paperId: string, totalScore: string) {
    return http.post<IUpdatePaperScore>(urlUpdatePaperScore, {
        paperId,
        totalScore
    });
}

export interface IUpdatePaperName {
    code: number;
    msg: string;
}
export function UpdatePaperName(paperId: string, paperName: string) {
    return http.post<IUpdatePaperName>(urlUpdatePaperName, {
        paperId,
        paperName
    });
}